import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const breadcrumbsLinkFn = /* @__PURE__ */ createRecipe('breadcrumbs-link', {}, [])

const breadcrumbsLinkVariantMap = {
  "color": [
    "danger"
  ]
}

const breadcrumbsLinkVariantKeys = Object.keys(breadcrumbsLinkVariantMap)

export const breadcrumbsLink = /* @__PURE__ */ Object.assign(memo(breadcrumbsLinkFn.recipeFn), {
  __recipe__: true,
  __name__: 'breadcrumbsLink',
  __getCompoundVariantCss__: breadcrumbsLinkFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: breadcrumbsLinkVariantKeys,
  variantMap: breadcrumbsLinkVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, breadcrumbsLinkVariantKeys)
  },
  getVariantProps: breadcrumbsLinkFn.getVariantProps,
})